/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button as ButtonComponent } from "reactstrap";
import * as styles from "./button.styles";

export const Button = ({ icon, iconOnlyOnMobile, rounded, children, className, isInBottomBar, color, ...props }) => {
    return (
        <div className={`d-inline-flex flex-column gap-1 align-items-center ${className ?? ""}`} css={isInBottomBar ? styles.launcherStyles : undefined}>
            <ButtonComponent
                className={`button text-nowrap d-flex align-items-center gap-2 justify-content-center ${isInBottomBar ? "" : "w-100"}`}
                css={rounded && styles.roundedStyles}
                color={color}
                {...props}
            >
                {icon && (
                    // eslint-disable-next-line no-nested-ternary
                    <div className="d-flex justify-content-center align-items-center" css={iconOnlyOnMobile || !children ? css`height: ${props.size === "sm" ? 21 : props.size === "lg" ? 30 : 24}px;` : undefined}>
                        <FontAwesomeIcon icon={icon} />
                    </div>
                )}

                {children && (
                    <span className={`text-nowrap ${iconOnlyOnMobile || isInBottomBar ? "d-none d-md-flex" : ""}`}>
                        {children}
                    </span>
                )}
            </ButtonComponent>

            {children && isInBottomBar && (
                <span className="d-md-none text-center" css={css`font-size: 12px;`}>
                    {children}
                </span>
            )}
        </div>
    );
};
